/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../components/sidebar/Sidebar2";
import Navbar from "../components/navbar/Navbar2";
import Footer from "../components/footer/Footer";
import DataTableTemplatingDemo from "../components/subscription/DataTableTemplatingDemo/DataTableTemplatingDemo";
import { Link } from "react-router-dom";
import {
    CreditCard,
    Clock,
    Package,
    CheckCircle,
    XCircle,
    Clock as ClockIcon,
    Award,
    Search,
    Star,
    Zap,
    Rocket,
    Users,
    Check,
} from "lucide-react";
import { useTranslation } from "react-i18next";

function FreeContent() {

    const [showSideBar, setShowSideBar] = useState(true);
    const { t, i18n } = useTranslation();

    return (
        <div className="container-fluid bg-purple-50 dark:!bg-[#181819] min-h-screen" dir={i18n.dir()}>
            <div className="row">
                {showSideBar && (
                    <div
                        style={{
                            width: "250px",
                            flexShrink: 0,
                            transition: "width 0.6s ease",
                            boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
                        }}
                    >
                        <Sidebar
                            showSideBar={showSideBar}
                            setShowSideBar={setShowSideBar}
                        />
                    </div>
                )}
                <div className="px-3 dark:!bg-[#181819]" style={{ flex: 1, backgroundColor: "#fbf8fc" }}>
                    <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
                    <div className="h-full flex flex-col items-center justify-center py-20 text-center bg-green-50 border border-dashed border-green-300 rounded-2xl m-10 shadow-sm dark:bg-[#1b1b1b] dark:!border-[#3c3a3d] dark:text-gray-200">

                        <ClockIcon className="w-10 h-10 text-green-600 mb-4 dark:text-green-400" />

                        <h2 className="text-xl font-bold text-green-700 mb-2 dark:text-green-400">
                            {t("freeAccessSection.title")}
                        </h2>

                        <p className="text-sm text-gray-600 max-w-md dark:text-gray-300">
                            {t("freeAccessSection.description")}
                        </p>
                    </div>

                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default FreeContent;
